import { render, staticRenderFns } from "./VehicleViewCustomer.vue?vue&type=template&id=059a4294"
import script from "./VehicleViewCustomer.vue?vue&type=script&lang=js"
export * from "./VehicleViewCustomer.vue?vue&type=script&lang=js"
import style0 from "./VehicleViewCustomer.vue?vue&type=style&index=0&id=059a4294&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports